import React from "react";
import { Link, useLocation } from "react-router-dom";
import PropTypes from "prop-types";

// react-bootstrap components
import {
  Badge,
  Button,
  ButtonGroup,
  Card,
  Collapse,
  Form,
  InputGroup,
  Navbar,
  Nav,
  Pagination,
  Container,
  Row,
  Col,
} from "react-bootstrap";
import { useHistory } from "react-router-dom";

import { useAuth0 } from "@auth0/auth0-react";

function UserProfile() {
  const { isAuthenticated, user, loginWithRedirect, logout, isLoading } = useAuth0();
  // this is for the user collapse
  const [userCollapseState, setUserCollapseState] = React.useState(false);

  let profileSection = <Button onClick={(e) => {
    e.preventDefault();
    loginWithRedirect({ redirect_uri: 'https://' + process.env.REACT_APP_HOST + '/' });
  }} >Log In</Button>;
  let profilePicture = null;
  if (isAuthenticated) {
    profileSection = (
      <span>
        {user.name} <b className="caret"></b>
      </span>);
    profilePicture = (<div className="photo">
      <img
        alt="..."
        src={user.picture}
      ></img>
    </div>);
  }

  return (
    <div className="user">
      {profilePicture}
      <div className="info">
        <a
          className={userCollapseState ? "collapsed" : ""}
          data-toggle="collapse"
          href="#pablo"
          onClick={(e) => {
            e.preventDefault();
            setUserCollapseState(!userCollapseState);
          }}
          aria-expanded={userCollapseState}
        >
          {profileSection}
        </a>
        <Collapse id="collapseExample" in={userCollapseState}>
          <div>
            <Nav as="ul">
              <li>
                <a
                  className="profile-dropdown"
                  onClick={(e) => {
                    e.preventDefault();
                    logout({ returnTo: 'https://' + process.env.REACT_APP_HOST + '/' });
                  }}
                >
                  <span className="sidebar-mini">L</span>
                  <span className="sidebar-normal">Logout</span>
                </a>
              </li>
            </Nav>
          </div>
        </Collapse>
      </div>
    </div>
  )
}


function Sidebar({ routes, image, background, databases }) {
  // to check for active links and opened collapses
  let location = useLocation();
  // this is for the rest of the collapses
  const [state, setState] = React.useState({});
  React.useEffect(() => {
    setState(getCollapseStates(routes));
  }, []);
  // this creates the intial state of this component based on the collapse routes
  // that it gets through routes prop
  const getCollapseStates = (routes) => {
    let initialState = {};
    routes.map((prop, key) => {
      if (prop.collapse) {
        initialState = {
          [prop.state]: getCollapseInitialState(prop, prop.views),
          ...getCollapseStates(prop.views),
          ...initialState,
        };
      }
      return null;
    });
    return initialState;
  };
  // this verifies if any of the collapses should be default opened on a rerender of this component
  // for example, on the refresh of the page,
  // while on the src/views/forms/RegularForms.jsx - route /admin/regular-forms
  const getCollapseInitialState = (prop, routes) => {
    if (prop.hasOwnProperty('isCollapsed')) {
      return prop.isCollapsed;
    }
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse && getCollapseInitialState(routes[i], routes[i].views)) {
        return true;
      } else if (location.pathname === routes[i].layout + routes[i].path) {
        return true;
      }
    }
    return false;
  };
  // this function creates the links and collapses that appear in the sidebar (left menu)
  const createLinks = (routes) => {
    return routes.map((prop, key) => {
      if (prop.collapse) {
        var st = {};
        st[prop["state"]] = !state[prop.state];
        return (
          <Nav.Item
            className={getCollapseInitialState(prop, prop.views) && !prop.isCollapsed ? "active" : ""}
            as="li"
            key={key}
          >
            <Nav.Link
              className={state[prop.state] ? "collapsed" : ""}
              data-toggle="collapse"
              onClick={(e) => {
                e.preventDefault();
                setState({ ...state, ...st });
              }}
              aria-expanded={state[prop.state]}
            >
              <i className={prop.icon}></i>
              <p>
                {prop.name} <b className="caret"></b>
              </p>
            </Nav.Link>
            <Collapse in={state[prop.state]}>
              <div>
                <Nav as="ul">{createLinks(prop.views)}</Nav>
              </div>
            </Collapse>
          </Nav.Item>
        );
      }
      return (
        <Nav.Item
          className={activeRoute(prop.layout + prop.path)}
          key={key}
          as="li"
        >
          <Nav.Link to={prop.layout + prop.path} as={Link}>
            {prop.icon ? (
              <>
                <i className={prop.icon} />
                <p>{prop.name}</p>
              </>
            ) : (
              <>
                <span className="sidebar-mini">{prop.mini}</span>
                <span className="sidebar-normal">{prop.name}</span>
              </>
            )}
          </Nav.Link>
        </Nav.Item>
      );
    });
  };
  // verifies if routeName is the one active (in browser input)
  const activeRoute = (routeName) => {
    return location.pathname === routeName ? "active" : "";
  };


  return (
    <>
      <div className="sidebar" data-color={background} data-image={image}>
        <div className="sidebar-wrapper">
          <div className="logo">
            <a
              className="simple-text logo-mini"
              href="http://rliable.com"
            >
            </a>
            <a
              className="simple-text logo-normal"
              href="https://rliable.com"
            >
              <img
                src={require("assets/img/logo.svg").default}
              />
            </a>
          </div>
          <UserProfile />
          <Nav as="ul">
            {createLinks(routes)}
            <DatabasesMenu databases={databases} />
          </Nav>
        </div>
        <div
          className="sidebar-background"
          style={{
            backgroundImage: "url('" + image + "')",
          }}
        ></div>
      </div>
    </>
  );
}

function DatabasesMenu({ databases }) {
  let history = useHistory();
  if (databases.length == 0) {
    return <></>;
  }

  var databaseListItems = databases.map((database) => {
    return (
      <Nav.Item
        className={database.id}
        key={database.id}
        as="li"
      >
        <Nav.Link to={"/database/" + database.id} as={Link}>
          <span className="sidebar-mini"></span>
          <span className="sidebar-normal">{database.name}</span>
        </Nav.Link>
      </Nav.Item>
    )
  });
  return (
    <Nav.Item
      className={""}
      as="li"
      key="databases"
    >
      <Nav.Link
        className={""}
        data-toggle="collapse"
        onClick={(e) => {
          e.preventDefault();
          history.push('/database/');
        }}
      >
        <i className="nc-icon nc-single-copy-04"></i>
        <p>
          Databases <b className="caret"></b>
        </p>
      </Nav.Link>
      <Collapse in={true}>
        <div>
          <Nav as="ul">{databaseListItems}</Nav>
        </div>
      </Collapse>
    </Nav.Item>);
}

let linkPropTypes = {
  path: PropTypes.string,
  layout: PropTypes.string,
  name: PropTypes.string,
  component: PropTypes.oneOfType([PropTypes.func, PropTypes.element]),
};

Sidebar.defaultProps = {
  image: "",
  background: "black",
  routes: [],
};

Sidebar.propTypes = {
  image: PropTypes.string,
  background: PropTypes.oneOf([
    "black",
    "azure",
    "green",
    "orange",
    "red",
    "purple",
  ]),
  routes: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.shape({
        ...linkPropTypes,
        icon: PropTypes.string,
      }),
      PropTypes.shape({
        collapse: true,
        path: PropTypes.string,
        name: PropTypes.string,
        state: PropTypes.string,
        icon: PropTypes.string,
        views: PropTypes.shape({
          ...linkPropTypes,
          mini: PropTypes.string,
        }),
      }),
    ])
  ),
};

export default Sidebar;
